"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductManufacturerSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ProductManufacturerSearchResponse extends common_1.PaginatedResponse {
}
exports.ProductManufacturerSearchResponse = ProductManufacturerSearchResponse;
//# sourceMappingURL=product-manufacturer-search.response.js.map